import { withT } from "neetocommons/react-utils";
import { Alert } from "neetoui";

const AlertBlock = withT(({ t, ...props }) => (
  <Alert
    data-testid="reset-alert"
    submitButtonLabel={t("neetoMolecules.common.actions.reset")}
    {...props}
  />
));

export default AlertBlock;
